import { useState, useEffect } from 'react';
import { hotelApi } from '../../hotelApi';

const H_GREEN = '#137333';
const H_LIGHT = '#e6f4ea';

function StatCard({ icon, label, value, color, bg, onClick }) {
  return (
    <div onClick={onClick}
      style={{
        background: bg || '#fff', borderRadius: 12, padding: '20px 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,.07)', display: 'flex', alignItems: 'center', gap: 16,
        cursor: onClick ? 'pointer' : 'default', border: `1px solid ${color}20`,
        transition: 'transform .15s, box-shadow .15s',
        flex: '1 1 160px', minWidth: 160,
      }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,.12)'; }}}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,.07)'; }}
    >
      <div style={{ width: 52, height: 52, borderRadius: 12, background: `${color}18`,
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, flexShrink: 0 }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 28, fontWeight: 800, color: color || '#202124', lineHeight: 1 }}>{value}</div>
        <div style={{ fontSize: 13, color: '#5f6368', marginTop: 4 }}>{label}</div>
      </div>
    </div>
  );
}

export default function HotelDashboard({ onNavigate, role }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hotelApi.getDashboard()
      .then(d => setStats(d))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#5f6368' }}>Loading dashboard…</div>;
  if (!stats) return <div style={{ padding: 40, textAlign: 'center', color: '#c5221f' }}>Could not load dashboard</div>;

  const fmtRs = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

  return (
    <div>
      {/* Welcome */}
      <div style={{ marginBottom: 24, padding: '20px 24px', background: 'linear-gradient(135deg,#0d3321,#1a4731)',
        borderRadius: 16, color: '#fff', boxShadow: '0 4px 16px rgba(13,51,33,.4)' }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>Welcome to Hotel Management</div>
        <div style={{ fontSize: 14, color: '#a8d5b8', marginTop: 6 }}>
          {new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
      </div>

      {/* Stats grid */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginBottom: 24 }}>
        <StatCard icon="🍽️" label="Tables Occupied" value={`${stats.occupiedTables} / ${stats.tableCount}`}
          color="#1a4731" onClick={() => onNavigate('tables')} />
        <StatCard icon="🛏️" label="Available Rooms" value={stats.availableRooms}
          color="#137333" onClick={() => onNavigate('rooms')} />
        <StatCard icon="📋" label="Today's Orders" value={stats.todayOrders}
          color="#0d7230" onClick={() => onNavigate('billing')} />
        <StatCard icon="₹" label="Today's Revenue" value={fmtRs(stats.todayRevenue)}
          color="#1e8449" onClick={() => onNavigate('billing')} />
        <StatCard icon="👨‍🍳" label="Pending Kitchen" value={stats.pendingKitchenItems}
          color={stats.pendingKitchenItems > 0 ? '#b45309' : '#137333'}
          onClick={() => onNavigate('kitchen')} />
        <StatCard icon="📦" label="Low Stock Items" value={stats.lowStockCount}
          color={stats.lowStockCount > 0 ? '#c5221f' : '#137333'}
          onClick={() => onNavigate('inventory')} />
      </div>

      {/* Quick links */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Quick Actions</div>
        </div>
        <div className="card-body" style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {[
            { icon: '🍽️', label: 'New Order', key: 'tables' },
            { icon: '👨‍🍳', label: 'Kitchen Display', key: 'kitchen' },
            { icon: '🧾', label: 'Generate Bill', key: 'billing' },
            { icon: '📋', label: 'Manage Menu', key: 'menu' },
            { icon: '📅', label: 'Bookings', key: 'bookings' },
            { icon: '📦', label: 'Inventory', key: 'inventory' },
          ].map(({ icon, label, key }) => (
            <button key={key} onClick={() => onNavigate(key)}
              style={{ background: H_LIGHT, color: H_GREEN, border: `1px solid ${H_GREEN}30`,
                borderRadius: 10, padding: '10px 18px', cursor: 'pointer', fontSize: 14,
                fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
              {icon} {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
